/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type NotificationsIcon_viewer = {
    readonly conversations?: {
        readonly metadata: {
            readonly lastUnreadMessageDate: string | null;
        } | null;
    } | null;
    readonly isAutomatedOfferNotificationDisabled: boolean | null;
    readonly " $refType": "NotificationsIcon_viewer";
};
export type NotificationsIcon_viewer$data = NotificationsIcon_viewer;
export type NotificationsIcon_viewer$key = {
    readonly " $data"?: NotificationsIcon_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"NotificationsIcon_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "NotificationsIcon_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isAutomatedOfferNotificationDisabled",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "disableAutomatedOfferBellNotification"
        }
      ],
      "storageKey": "isEnabled(key:\"disableAutomatedOfferBellNotification\")"
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "conversations",
          "storageKey": "conversations(filter:\"showUnreadOnly\")",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": "showUnreadOnly"
            }
          ],
          "concreteType": "ConversationConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "metadata",
              "storageKey": null,
              "args": null,
              "concreteType": "ConversationMetadata",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "lastUnreadMessageDate",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '650dc7a83096d9485a033d06212388c3';
export default node;
